/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Console_Copy_FailedInputs */

const en_console_copy_failed = /** @type {(inputs: Console_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy failed. Select and copy the prompt shown below.`)
};

const zh_hans1_console_copy_failed = /** @type {(inputs: Console_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制失败。请选中并复制下方显示的提示词。`)
};

const pt_br2_console_copy_failed = /** @type {(inputs: Console_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao copiar. Selecione e copie o prompt abaixo.`)
};

const es_console_copy_failed = /** @type {(inputs: Console_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo copiar. Selecciona y copia el prompt que aparece abajo.`)
};

const fr_console_copy_failed = /** @type {(inputs: Console_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la copie. Sélectionnez et copiez le prompt affiché ci-dessous.`)
};

const de_console_copy_failed = /** @type {(inputs: Console_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren fehlgeschlagen. Markiere den unten gezeigten Prompt und kopiere ihn.`)
};

const ru_console_copy_failed = /** @type {(inputs: Console_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось скопировать. Выделите и скопируйте промпт, показанный ниже.`)
};

const it_console_copy_failed = /** @type {(inputs: Console_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia non riuscita. Seleziona e copia il prompt mostrato qui sotto.`)
};

/**
* | output |
* | --- |
* | "Copy failed. Select and copy the prompt shown below." |
*
* @param {Console_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_copy_failed = /** @type {((inputs?: Console_Copy_FailedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Copy_FailedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_copy_failed(inputs)
	if (locale === "pt-BR") return pt_br2_console_copy_failed(inputs)
	if (locale === "es") return es_console_copy_failed(inputs)
	if (locale === "fr") return fr_console_copy_failed(inputs)
	if (locale === "de") return de_console_copy_failed(inputs)
	if (locale === "ru") return ru_console_copy_failed(inputs)
	if (locale === "it") return it_console_copy_failed(inputs)
	return en_console_copy_failed(inputs)
});